import React, { InputHTMLAttributes } from 'react';
import classNames from 'classnames';
import { componentSizeVariantsEnum } from 'src/constants/common.constants';

type TInputElement2Props = {
  variant?: componentSizeVariantsEnum;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  onStartIconClick?: () => void;
  onEndIconClick?: () => void;
  hasError?: boolean;
} & InputHTMLAttributes<HTMLInputElement>;

const InputElement2 = ({
  variant = componentSizeVariantsEnum.MEDIUM,
  startIcon,
  endIcon,
  onStartIconClick,
  onEndIconClick,
  hasError = false,
  className,
  disabled,
  ...rest
}: TInputElement2Props) => {
  return (
    <div
      className={classNames(
        'input-element-v2',
        `input-element-v2--${variant}`,
        {
          'input-element-v2--error': hasError,
          'input-element-v2--disabled': disabled
        },
        className
      )}
    >
      {startIcon && (
        <div 
          className="start-icon-v2" 
          onClick={onStartIconClick}
          style={{ cursor: onStartIconClick ? 'pointer' : 'default' }}
        >
          {startIcon}
        </div>
      )}
      
      <input
        {...rest}
        disabled={disabled}
      />
      
      {endIcon && (
        <div 
          className="end-icon-v2" 
          onClick={onEndIconClick}
          style={{ cursor: onEndIconClick ? 'pointer' : 'default' }}
        >
          {endIcon}
        </div>
      )}
    </div>
  );
};

export default InputElement2;
